<template>
  <div class="main-layout">
    <top-bar class="top-bar"></top-bar>
    <service-lists class="photographer-list"></service-lists>
    <footer-menu></footer-menu>
  </div>
</template>

<script>
import TopBar from '../common/TopBar.vue'
import ServiceLists from './ServiceLists.vue'
import FooterMenu from '../common/FooterMenu'

export default {
  name: 'main-layout',
  components: {
    FooterMenu,
    ServiceLists,
    TopBar
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  top: 20px;
  position: relative;
  margin: auto;
  width: 1118px;

  /*border: 1px dotted gray;*/
  .top-bar {
    position: relative;
    margin: auto;
    width: 1080px;
  }

  .photographer-list {
    position: relative;
    margin: 20px auto auto auto;
    width: 1090px;
  }
}
</style>
